import { APIs } from "./APIs";
import { getPath } from "../utils/getPath";

import type { AxiosInstance } from "axios";

import API = APIs.bluxUsersCollectEventsV2;

export const collectEvent = (
  instance: AxiosInstance,
  pathParams: API.PathParam,
  body: API.Body,
  headers: Record<string, string>,
) => {
  return instance[API.method]<API.ResponseData>(
    getPath(API.path, pathParams),
    body,
    { headers },
  );
};
